import React, { useEffect, useMemo } from 'react';
import HashtagVideoTableList from '../HashtagVideoTable';
import { useHashtagDetailsVideoList } from '@opm/pages/Hashtag/hooks';

interface IHashtagVideoWrapperProps {
  detailsFilter: any;
  selectedKol: {
    anchor_uid: string;
    anchor_name: string;
  }[];
  setSelectedKol: (kols: {
    anchor_uid: string;
    anchor_name: string;
  }[]) => void;
  wholePageRef: React.RefObject<HTMLDivElement>;
  translateCategory: (text: string, isEn: boolean) => string;
}
export default function HashtagVideoWrapper(props: IHashtagVideoWrapperProps) {
  const { detailsFilter, selectedKol, setSelectedKol, wholePageRef, translateCategory } = props;

  const filter = useMemo(() => {
    return {
      ...detailsFilter,
      anchor_uids: selectedKol?.map(kol => kol.anchor_uid) || [],
    };
  }, [detailsFilter, selectedKol]);

  const { nextPage, resetData, operation, loading, ...restVideoProps } = useHashtagDetailsVideoList({
    filter,
    translateCategory
  });

  useEffect(() => {
    const container = wholePageRef?.current;
    if (!container) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      // adjust threshold to your liking (80px before bottom)
      const isBottom = scrollTop + clientHeight >= scrollHeight - 20;

      if (isBottom && !loading) {
        nextPage(); // trigger next page load
      }
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [wholePageRef, nextPage, loading]);

  return (
    <HashtagVideoTableList
      operation={operation}
      selectedKol={selectedKol}
      setSelectedKol={setSelectedKol}
      loading={loading}
      {...restVideoProps}>
    </HashtagVideoTableList>
  );
} 